// Sub-calendar API helpers (Batch 38 — Phase A foundation).
//
// Endpoints:
//   GET    /api/families/:fid/calendars
//   POST   /api/families/:fid/calendars
//   PATCH  /api/families/:fid/calendars/:cid
//   DELETE /api/families/:fid/calendars/:cid          (soft-deletes, reassigns events to default)
import { api } from "@/lib/api";

export async function listCalendars(familyId) {
  if (!familyId) return [];
  const { data } = await api.get(`/families/${familyId}/calendars`);
  return data || [];
}

export async function createCalendar(familyId, body) {
  const { data } = await api.post(`/families/${familyId}/calendars`, body);
  return data;
}

export async function updateCalendar(familyId, calendarId, patch) {
  const { data } = await api.patch(
    `/families/${familyId}/calendars/${calendarId}`,
    patch,
  );
  return data;
}

export async function deleteCalendar(familyId, calendarId) {
  const { data } = await api.delete(`/families/${familyId}/calendars/${calendarId}`);
  return data;
}

// ── Local UI prefs: which sub-calendars are HIDDEN per family. Persisted ──
// to localStorage so the user's filter sticks across reloads. Default state
// (no key) means "show all" — first-run shows everything.
export function getHiddenCalendarIds(familyId) {
  if (!familyId) return new Set();
  try {
    const raw = localStorage.getItem(`kinly:cal-hidden-sub:${familyId}`);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) || []);
  } catch {
    return new Set();
  }
}

export function setHiddenCalendarIds(familyId, idSet) {
  if (!familyId) return;
  try {
    localStorage.setItem(
      `kinly:cal-hidden-sub:${familyId}`,
      JSON.stringify([...idSet]),
    );
  } catch { /* ignore */ }
}

// ── Default colour palette for new sub-calendars. Hex strings. ──
export const CALENDAR_PALETTE = [
  "#6366f1", "#ec4899", "#f59e0b", "#10b981",
  "#06b6d4", "#8b5cf6", "#ef4444", "#84cc16",
  "#f97316", "#3b82f6", "#14b8a6", "#a855f7",
];

export const CALENDAR_KINDS = [
  { key: "personal", label: "Personal", icon: "user" },
  { key: "school", label: "School", icon: "graduation-cap" },
  { key: "activity", label: "Activity", icon: "trophy" },
  { key: "work", label: "Work", icon: "briefcase" },
  { key: "holidays", label: "Holidays", icon: "palmtree" },
  { key: "other", label: "Other", icon: "calendar" },
];

export const CALENDAR_VISIBILITY = [
  { key: "family", label: "Everyone in family", desc: "All members can see events on this calendar." },
  { key: "parents_only", label: "Parents / guardians", desc: "Hidden from kids and teens." },
  { key: "private", label: "Private to subscribers", desc: "Only the owner + people you pick can see." },
];
